// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gou_pA60L7HZQoba2CLU {
  margin-left: auto;
  margin-right: auto;
  margin-top: 2.5rem;
  height: 85vh;
  border-radius: 20px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 2.5rem;
  padding-bottom: 0.75rem;
}

.Q_uhVPuXaUlg1LLlvFjg {
  margin-left: auto;
  margin-right: auto;
  margin-top: 2.5rem;
  height: 70vh;
  border-radius: 20px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 2.5rem;
  padding-bottom: 0.75rem;
}

.uGm4NwAPjgus2NV03pag {
  margin-bottom: 1.5rem;
  padding-left: 1.75rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
}

.FjaH5YYvbbEGy1rPJBNA {
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(26 26 26 / var(--tw-text-opacity, 1));
}

.HhZlQW4oKyLmZoTLmBnv {
  margin-bottom: 1rem;
  font-size: 1rem;
  line-height: 1.5rem;
  line-height: 1.625;
  --tw-text-opacity: 1;
  color: rgb(94 94 94 / var(--tw-text-opacity, 1));
}

.TMz34X0U3vTt1f9yRTAP {
  display: flex;
  min-height: 100vh;
  justify-content: center;
  padding-left: 8rem;
  padding-right: 8rem;
  background: linear-gradient(
    116.81deg,
    rgba(188, 211, 228, 0.25) -7.65%,
    rgba(255, 255, 255, 0.25) 71.29%
  );
}

.v52WSVMlZMY8jj_k_bOK {
  height: 56vh;
  list-style-position: inside;
  list-style-type: decimal;
}

.v52WSVMlZMY8jj_k_bOK > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}

.v52WSVMlZMY8jj_k_bOK {
  overflow-y: scroll;
  font-family: Noto Sans;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  line-height: 1.625;
  --tw-text-opacity: 1;
  color: rgb(26 26 26 / var(--tw-text-opacity, 1));
  padding-left: 1.75rem;
}

.sd7joUfQdb2wmzzLMm0b {
  height: 68vh;
  list-style-position: inside;
  list-style-type: decimal;
}

.sd7joUfQdb2wmzzLMm0b > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}

.sd7joUfQdb2wmzzLMm0b {
  overflow-y: scroll;
  font-family: Noto Sans;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  line-height: 1.625;
  --tw-text-opacity: 1;
  color: rgb(26 26 26 / var(--tw-text-opacity, 1));
  padding-left: 1.75rem;
}

.CadunYFh1SklSjyNXyAQ {
  height: 38px;
  width: 120px;
  --tw-bg-opacity: 1;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.CadunYFh1SklSjyNXyAQ:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.JLdyanaPlPKpF3wdrFTU {
  display: flex;
  justify-content: flex-end;
  padding-right: 2rem;
}

@media (max-width: 767px) {
  .JLdyanaPlPKpF3wdrFTU {
    display: none;
  }

  .TMz34X0U3vTt1f9yRTAP {
    padding: 16px;
  }

  .TMz34X0U3vTt1f9yRTAP > div {
    width: 100%;
    min-width: 0;
  }

  .Q_uhVPuXaUlg1LLlvFjg,
  .gou_pA60L7HZQoba2CLU {
    height: auto;
    margin-top: 0;
    padding: 24px 16px;
  }

  .uGm4NwAPjgus2NV03pag {
    padding-left: 0;
  }

  .v52WSVMlZMY8jj_k_bOK,
  .sd7joUfQdb2wmzzLMm0b {
    height: auto;
    overflow: visible;
    padding-left: 0;
    font-size: 16px;
  }

  .TMz34X0U3vTt1f9yRTAP > div > div:last-child {
    padding-right: 0;
    margin-top: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Terms/Terms.module.css"],"names":[],"mappings":"AACE;EAAA,iBAAqE;EAArE,kBAAqE;EAArE,kBAAqE;EAArE,YAAqE;EAArE,mBAAqE;EAArE,kBAAqE;EAArE,4DAAqE;EAArE,oBAAqE;EAArE,qBAAqE;EAArE,mBAAqE;EAArE;AAAqE;;AAIrE;EAAA,iBAAqE;EAArE,kBAAqE;EAArE,kBAAqE;EAArE,YAAqE;EAArE,mBAAqE;EAArE,kBAAqE;EAArE,4DAAqE;EAArE,oBAAqE;EAArE,qBAAqE;EAArE,mBAAqE;EAArE;AAAqE;;AAIrE;EAAA,qBAAsC;EAAtC,qBAAsC;EAAtC,mBAAsC;EAAtC,oBAAsC;EAAtC;AAAsC;;AAItC;EAAA,kBAAoD;EAApD,qBAAoD;EAApD,kBAAoD;EAApD,oBAAoD;EAApD,gBAAoD;EAApD,oBAAoD;EAApD;AAAoD;;AAIpD;EAAA,mBAAmD;EAAnD,eAAmD;EAAnD,mBAAmD;EAAnD,kBAAmD;EAAnD,oBAAmD;EAAnD;AAAmD;;AAInD;EAAA,aAA6C;EAA7C,iBAA6C;EAA7C,uBAA6C;EAA7C,kBAA6C;EAA7C,mBAA6C;EAC7C;;;;;AAD6C;;AAS7C;EAAA,YAAiI;EAAjI,2BAAiI;EAAjI;AAAiI;;AAAjI;EAAA,uBAAiI;EAAjI,4DAAiI;EAAjI;AAAiI;;AAAjI;EAAA,kBAAiI;EAAjI,sBAAiI;EAAjI,mBAAiI;EAAjI,oBAAiI;EAAjI,gBAAiI;EAAjI,kBAAiI;EAAjI,oBAAiI;EAAjI,gDAAiI;EACjI;AADiI;;AAKjI;EAAA,YAAiI;EAAjI,2BAAiI;EAAjI;AAAiI;;AAAjI;EAAA,uBAAiI;EAAjI,4DAAiI;EAAjI;AAAiI;;AAAjI;EAAA,kBAAiI;EAAjI,sBAAiI;EAAjI,mBAAiI;EAAjI,oBAAiI;EAAjI,gBAAiI;EAAjI,kBAAiI;EAAjI,oBAAiI;EAAjI,gDAAiI;EACjI;AADiI;;AAKjI;EAAA,YAA2D;EAA3D,YAA2D;EAA3D,kBAA2D;EAA3D,0DAA2D;EAA3D,oBAA2D;EAA3D,qBAA2D;EAA3D,mBAA2D;EAA3D,sBAA2D;EAA3D,oBAA2D;EAA3D;AAA2D;;AAI3D;EAAA,6BAAgC;EAAhC,qEAAgC;EAAhC,+BAAgC;EAAhC;AAAgC;;AAIhC;EAAA,aAA4B;EAA5B,yBAA4B;EAA5B;AAA4B;;AAG9B;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":[".fullContainer {\n  @apply mx-auto px-6 pt-10 pb-3 bg-white rounded-[20px] h-[85vh] mt-10;\n}\n\n.container {\n  @apply mx-auto px-6 pt-10 pb-3 bg-white rounded-[20px] h-[70vh] mt-10;\n}\n\n.title {\n  @apply text-lg font-semibold mb-6 pl-7;\n}\n\n.subtitle {\n  @apply text-xl font-semibold mt-6 mb-2 text-gray-700;\n}\n\n.text {\n  @apply text-base leading-relaxed text-gray-600 mb-4;\n}\n\n.gradientBg {\n  @apply flex justify-center min-h-screen px-32;\n  background: linear-gradient(\n    116.81deg,\n    rgba(188, 211, 228, 0.25) -7.65%,\n    rgba(255, 255, 255, 0.25) 71.29%\n  );\n}\n\n.list {\n  @apply list-decimal list-inside space-y-4 text-gray-700 leading-relaxed text-sm font-normal overflow-y-scroll h-[56vh] font-inter;\n  padding-left: 1.75rem;\n}\n\n.fullList {\n  @apply list-decimal list-inside space-y-4 text-gray-700 leading-relaxed text-sm font-normal overflow-y-scroll h-[68vh] font-inter;\n  padding-left: 1.75rem;\n}\n\n.applyButton {\n  @apply bg-secondary text-white px-6 py-2 w-[120px] h-[38px];\n}\n\n.applyButton:hover {\n  @apply !bg-secondary !text-white;\n}\n\n.backToLogin {\n  @apply flex justify-end pr-8;\n}\n\n@media (max-width: 767px) {\n  .backToLogin {\n    display: none;\n  }\n\n  .gradientBg {\n    padding: 16px;\n  }\n\n  .gradientBg > div {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .container,\n  .fullContainer {\n    height: auto;\n    margin-top: 0;\n    padding: 24px 16px;\n  }\n\n  .title {\n    padding-left: 0;\n  }\n\n  .list,\n  .fullList {\n    height: auto;\n    overflow: visible;\n    padding-left: 0;\n    font-size: 16px;\n  }\n\n  .gradientBg > div > div:last-child {\n    padding-right: 0;\n    margin-top: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fullContainer": `gou_pA60L7HZQoba2CLU`,
	"container": `Q_uhVPuXaUlg1LLlvFjg`,
	"title": `uGm4NwAPjgus2NV03pag`,
	"subtitle": `FjaH5YYvbbEGy1rPJBNA`,
	"text": `HhZlQW4oKyLmZoTLmBnv`,
	"gradientBg": `TMz34X0U3vTt1f9yRTAP`,
	"list": `v52WSVMlZMY8jj_k_bOK`,
	"fullList": `sd7joUfQdb2wmzzLMm0b`,
	"applyButton": `CadunYFh1SklSjyNXyAQ`,
	"backToLogin": `JLdyanaPlPKpF3wdrFTU`
};
export default ___CSS_LOADER_EXPORT___;
